import { useContext } from "react";
import { UserContext } from "../Controllers/UserContext";
import { FiShoppingCart, FiHeart } from "react-icons/fi";
import fungal1 from "../assets/products/fungal_1.jpg";
import "./Wishlist.css";
import Variables from '../Variables.json'
import Breadcrumb from '../Components/Breadcrumb';

const baseUrl = Variables.baseUrl;

const isSpecialProduct = (name) => {
    if (!name) return false;
    const n = name.toLowerCase().trim();
    return n.includes("chilli") || n.includes("greengram") || n.includes("blackgram") || n.includes("chillis");
};

const isComingSoon = (product) => {
    if (!product) return false;
    const name = (product.productname || product.ProductName || "").toLowerCase().trim();
    const isTarget = isSpecialProduct(name);
    if (!isTarget) return false;
    const price = parseFloat(product.Price1 || product.Price || 0);
    return price <= 1.00;
};

export default function Wishlist() {
    const { setWishlistItems, setCartItems, wishlistItems, cartItems, removeFromWishlist } = useContext(UserContext);

    // Helper function to parse price
    const parsePrice = (price) => {
        if (!price) return 0;
        return parseFloat(price) || 0;
    };

    const addToCart = (product) => {
        if (isComingSoon(product)) {
            alert("This product is Coming Soon and cannot be ordered.");
            return;
        }
        const exists = cartItems.some(item => item.Productid === product.Productid);
        if (!exists) {
            setCartItems(prevItems => [...prevItems, {
                ...product,
                quantity: 1,
                selectedPack: 'Pack1'
            }]);
        }
    };

    const moveAllToCart = () => {
        wishlistItems.forEach(product => {
            if (isComingSoon(product)) return;
            const exists = cartItems.some(item => item.Productid === product.Productid);
            if (!exists) {
                setCartItems(prevItems => [...prevItems, {
                    ...product,
                    quantity: 1,
                    selectedPack: 'Pack1'
                }]);
            }
        });
    };

    return (
        <div className="container mt-2">        
            <Breadcrumb />
            <div className="wishlist-container">
            <div className="wishlist-header">
                <h1 className="wishlist-title">Wishlist</h1>
                {wishlistItems.length > 0 && (
                    <button className="move-all-btn" onClick={moveAllToCart}>
                        Move all to cart
                    </button>
                )}
            </div>

            {wishlistItems.length === 0 ? (
                <div className="empty-wishlist">
                    <FiHeart size={64} />
                    <p>Your wishlist is empty</p>
                    <p className="empty-subtitle">Save items you love for later</p>
                </div>
            ) : (
                <div className="wishlist-grid">
                    {wishlistItems.map((product) => {
                        const currentPrice = parsePrice(product.Price1 || product.Price);
                        const originalPrice = parsePrice(product.Price3 || product.MRP);

                        return (
                            <div key={product.Productid} className="wishlist-card">
                                <img
                                    src={baseUrl + product.Image}
                                    alt={product.productname}
                                    className="wishlist-image"
                                    onError={(e) => { e.target.src = fungal1; }}
                                />
                                <div className="wishlist-info">
                                    <h3 className="wishlist-product-name">{product.productname}</h3>

                                    <div className="wishlist-price">
                                        {isComingSoon(product) ? (
                                            <span className="badges badge-coming-soon" style={{ backgroundColor: '#d97706', color: 'white', padding: '4px 12px', borderRadius: '4px', fontSize: '0.85rem', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                                                Coming Soon 🔒
                                            </span>
                                        ) : (
                                            <>
                                                {originalPrice > 0 && originalPrice > currentPrice && (
                                                    <span className="wishlist-original-price">₹{originalPrice.toFixed(2)}</span>
                                                )}
                                                <span className="wishlist-current-price">
                                                    ₹{currentPrice.toFixed(2)}
                                                </span>
                                            </>
                                        )}
                                    </div>

                                    <div className="wishlist-actions">
                                        {isComingSoon(product) ? (
                                            <button
                                                className="wishlist-add-cart-btn disabled-lock"
                                                style={{ backgroundColor: '#d97706', cursor: 'not-allowed', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}
                                                disabled
                                            >
                                                Coming Soon 🔒
                                            </button>
                                        ) : (
                                            <button
                                                className="wishlist-add-cart-btn"
                                                onClick={() => addToCart(product)}
                                            >
                                                <FiShoppingCart size={18} /> Add to Cart
                                            </button>
                                        )}
                                        <button
                                            className="wishlist-remove-btn"
                                            onClick={() => removeFromWishlist(product.Productid)}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            </div>
        </div>
    );
}